/**
 * Checkbox theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/checkbox.ts
 */
import { checkboxAnatomy as parts } from '@chakra-ui/anatomy';
const defaultStylesControl = {
    bg: 'brand.gray-scale-border-10',
    borderColor: 'brand.gray-scale-border-20',
};
export const Checkbox = {
    parts: parts.keys,
    baseStyle() {
        return {
            control: {
                ...defaultStylesControl,
                _checked: {
                    color: 'brand.secondary-sky-blue',
                    ...defaultStylesControl,
                    _hover: defaultStylesControl,
                },
                _hover: defaultStylesControl,
            },
        };
    },
    variants: {},
    sizes: {},
    defaultProps: {},
};
